//对树形结构数据根据某一属性进行过滤，返回一个新的树形
//用法如  getTree(list, node => node.type === 1);
function deal(nodes, predicate) {
  // 如果已经没有节点了，结束递归
  if (!(nodes && nodes.length)) {
    return [];
  }
  const newChildren = [];
  for (const node of nodes) {
    if (predicate(node)) {
      // 如果节点符合条件，直接加入新的节点集
      //为了采集菜单节点的id
      node.meta = {
        label: node.id,
      };
      newChildren.push(node);
      node.children = deal(node.children, predicate);
    } else {
      // 如果当前节点不符合条件，递归过滤子节点，
      // 把符合条件的子节点提升上来，并入新节点集
      newChildren.push(...deal(node.children, predicate));
    }
  }
  return newChildren;
}

export default deal;
